import {useRecorrenceCoursesQuery} from './useRecorrenceCoursesQuery'
import {usePosCoursesQuery} from './usePosCoursesQuery'

const byProfessorName = name => course => {
  return course.professor.includes(name)
}

const byProfessorsName = name => course => {
  return course.professors.includes(name)
}
const useGetCoursesOfProfessor = professorName => {
  const recorrenceCourses = useRecorrenceCoursesQuery()
  const posCourses = usePosCoursesQuery()

  console.log({recorrenceCourses, posCourses})
  return [
    ...recorrenceCourses.filter(byProfessorName(professorName)),
    ...posCourses.filter(byProfessorsName(professorName)),
  ]
}

export {useGetCoursesOfProfessor}
